export function getAttributes(el, prefix = null) {
  // turn the nodelist into an array
  return Array.prototype.slice
    .call(el.attributes)
    .reduce((acc, attributeNode) => {
      // turn the array into an object
      let name = attributeNode.nodeName;
      let value = attributeNode.nodeValue.trim();
      if (prefix) {
        if (name.startsWith(prefix)) {
          name = name.replace(prefix, "");
        } else {
          return acc;
        }
      }
      // parse objects or arrays
      if (value.charAt(0) === "{" && value.charAt(value.length - 1) === "}") {
        value = JSON.parse(value);
      } else if (
        value.charAt(0) === "[" &&
        value.charAt(value.length - 1) === "]"
      ) {
        value = JSON.parse(value);
      }
      acc[name] = value;
      return acc;
    }, {});
}
